import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
} from "devextreme-react/data-grid";
import moment from "moment";
import { formatMessage } from "devextreme/localization";
import { useSelector, useDispatch } from "react-redux";
import { showTimekeepingOnlineData } from "../../../redux/actions";
import { responseTimekeeping } from "../../../redux/reducers";
import { useScreenSize } from "../../../utils/media-query";

import ToolbarBefore from "../../../components/toolbar-before/ToolbarBefore";
import ToolbarAfter from "./ToolbarAfter";
import { useAuth } from "../../../contexts/auth";

export default function TimekeepingOnlineDataTableList({
  dataGrid,
  middleware,
}) {
  const { user } = useAuth();
  const [status, setStatus] = React.useState();
  const [fromDate, setFromDate] = React.useState();
  const [toDate, setToDate] = React.useState();
  const { isXSmall, isSmall } = useScreenSize();
  const dispatch = useDispatch();
  const { timekeepingOnlineData } = useSelector(responseTimekeeping);

  const handleChangeSelectBox = async () => {
    const FromDate = moment(new Date(fromDate)).format();
    const ToDate = moment(new Date(toDate)).format();

    const payload = {
      Status: status,
      FromDate: FromDate,
      ToDate: ToDate,
      EmployeeOid: user?.EmployeeOid,
    };
    dispatch(showTimekeepingOnlineData(payload));
  };
  return (
    <DataGrid
      id="gridContainer"
      height={document.documentElement.offsetHeight - 189}
      showBorders={true}
      showRowLines={true}
      hoverStateEnabled={true}
      rowAlternationEnabled={true}
      columnAutoWidth={true}
      columnResizingMode="widget"
      alignment="center"
      allowColumnReordering={true}
      allowColumnResizing={true}
      columnHidingEnabled={true}
      ref={(e) => {
        dataGrid.current = e;
      }}
      dataSource={timekeepingOnlineData}
    >
      {/* <SearchPanel
        visible={true}
        width={240}
        className="datagrid-toolbar-search-panel"
        placeholder="Search..."
      /> */}
      <Selection
        mode="multiple"
        selectAllMode="page"
        showCheckBoxesMode="always"
      />
      <FilterRow visible={true} />
      <Paging defaultPageSize={10} />
      <Pager
        showPageSizeSelector={true}
        allowedPageSizes={[10, 20, 50, 100]}
        showInfo={true}
        visible={true}
      />
      <Column
        caption={formatMessage("EmployeeCode")}
        dataField="Employee.EmployeeCode"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 1 : false}
      />
      <Column
        caption={formatMessage("EmployeeName")}
        dataField="Employee.FullName"
        dataType="string"
      />
      <Column
        caption={formatMessage("DepartmentCode")}
        dataField="Employee.Department.DepartmentCode"
        dataType="string"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption={formatMessage("DepartmentName")}
        dataField="Employee.Department.DepartmentName"
        dataType="string"
        hidingPriority={isXSmall ? 1 : false}
      />
      <Column
        caption={formatMessage("PositionName")}
        dataField="Employee.Position.PositionName"
        dataType="string"
      />
      <Column
        caption={formatMessage("Shift")}
        dataField="Shift.Name"
        dataType="string"
      />
      <Column
        caption={formatMessage("Date")}
        dataField="LogTime"
        dataType="date"
        format="dd/MM/yyyy"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption={formatMessage("RequestStatus")}
        dataField="RequestStatus"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption={formatMessage("PrevApprovalName")}
        dataField="PrevApprovalName"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption={formatMessage("PrevApprovedDate")}
        dataField="PrevApprovedDate"
        dataType="date"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption={formatMessage("PrevApprovalStatus")}
        dataField="PrevApprovalStatus"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption={formatMessage("PrevApprovalComments")}
        dataField="PrevApprovalComments"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption={formatMessage("CurrentApprovalName")}
        dataField="CurrentApprovalName"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption={formatMessage("CancelReason")}
        dataField="CancelReason"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Column
        caption={formatMessage("CancelDate")}
        dataField="CanceledDate"
        dataType="date"
        hidingPriority={isXSmall || isSmall ? 3 : false}
      />
      <Toolbar className="datagrid-toolbar-actions">
        <Item
          location="before"
          locateInMenu={isXSmall || isSmall ? "always" : "auto"}
          cssClass={"datagrid-toolbar-actions-dropdown"}
        >
          <ToolbarBefore
            middleware={middleware}
            setFromDate={setFromDate}
            setToDate={setToDate}
            dataGrid={dataGrid}
            setStatus={setStatus}
            handleChangeSelectBox={handleChangeSelectBox}
          />
        </Item>
        <Item
          location="after"
          locateInMenu={isXSmall || isSmall ? "always" : "auto"}
          cssClass={"datagrid-toolbar-actions-dropdown"}
        >
          <ToolbarAfter middleware={middleware} dataGrid={dataGrid} />
        </Item>
      </Toolbar>
    </DataGrid>
  );
}
